import './App.css';
import React from 'react';
import Main from './main/Main.jsx';


function App() {

  return (
    <div className="App">
     <Main />
    </div>
  );
}

export default App;
 